// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

// Hardcoded Supabase project credentials. Do NOT revert to import.meta.env.
// Exported so edge function bypass calls (direct fetch) can reuse them.
// Public API host is the Supabase custom domain (api.nynch.com) so OAuth
// redirect URIs live on a domain we own (Google app verification). The
// project host below still serves and is kept for host-specific endpoints.
export const SUPABASE_PROJECT_REF = "crcrwtjzqzinfzokianr";
export const SUPABASE_PROJECT_URL = `https://${SUPABASE_PROJECT_REF}.supabase.co`;
export const SUPABASE_URL = "https://api.nynch.com";
// supabase-js derives its default storage key from the URL's first hostname
// label ("sb-api-auth-token" for api.nynch.com). Pin the key the app has always
// used so switching hosts does not sign every user out.
export const SUPABASE_AUTH_STORAGE_KEY = `sb-${SUPABASE_PROJECT_REF}-auth-token`;
export const SUPABASE_PUBLISHABLE_KEY = "sb_publishable_yS_OQfhEgxTEqQHwymi7Dw_6GX7mR6i";

const authStorage =
  typeof window !== 'undefined' && typeof window.localStorage !== 'undefined'
    ? window.localStorage
    : undefined;

// Use a separate storage key for the demo preview iframe to avoid
// overwriting a real user's auth session in localStorage.
const isDemoPreviewRoute =
  typeof window !== 'undefined' && window.location.pathname.startsWith('/demo-preview');

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

const authOptions = {
  storage: authStorage,
  storageKey: isDemoPreviewRoute ? 'sb-demo-preview-auth' : SUPABASE_AUTH_STORAGE_KEY,
  persistSession: true,
  autoRefreshToken: true,
  // Default 5s is too short - concurrent requests (streaming, queries,
  // refresh checks) compete for the navigator lock and the loser gets a
  // "lock stolen" error that cascades into save/load failures.
  lockAcquireTimeout: 15_000,
};

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: authOptions,
});

// Session-safe getUser() override.
//
// gotrue-js's getUser() makes a server call to /auth/v1/user on every call.
// If that call gets a transient 401, gotrue-js can remove an otherwise valid
// local session. The app callers use getUser() to extract user.id for
// RLS-scoped queries, so we use the local session cache unless a JWT is passed.

const _originalGetUser = supabase.auth.getUser.bind(supabase.auth);

supabase.auth.getUser = (async (jwt?: string) => {
  if (jwt) return _originalGetUser(jwt);

  const { data: { session } } = await supabase.auth.getSession();
  if (session?.user) {
    return { data: { user: session.user }, error: null };
  }
  return { data: { user: null }, error: null };
}) as typeof supabase.auth.getUser;
